import axios from 'axios';

const API_URL = process.env.REACT_APP_QWIKBISTRO_API_URL || 'https://qwikbistro.shop';
const TOKEN = process.env.REACT_APP_QWIK_BISTRO_API_TOKEN;

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': `Bearer ${TOKEN}`,
    'Content-Type': 'application/json',
  },
});

export const recipeApiService = {
  // Get all recipes
  getAllRecipes: async () => {
    try {
      const response = await axiosInstance.get('/recipeCost/');
      return response.data.reverse(); // Reverse to show latest first
    } catch (error) {
      console.error('Error fetching recipes:', error);
      throw error;
    }
  },

  // Get single recipe
  getRecipe: async (id) => {
    try {
      const response = await axiosInstance.get(`/recipeCost/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching recipe:', error);
      throw error;
    }
  },

  // Update recipe
  updateRecipe: async (id, recipeData) => {
    try {
      const response = await axiosInstance.patch(`/recipeCost/${id}`, recipeData);
      return response.data;
    } catch (error) {
      console.error('Error updating recipe:', error);
      throw error;
    }
  },

  // Delete recipe
  deleteRecipe: async (id) => {
    try {
      await axiosInstance.delete(`/recipeCost/${id}`);
      return true;
    } catch (error) {
      console.error('Error deleting recipe:', error);
      throw error;
    }
  },

  // Create new recipe
  createRecipe: async (recipeData) => {
    try {
      const response = await axiosInstance.post('/recipeCost/new', recipeData);
      return response.data;
    } catch (error) {
      console.error('Error creating recipe:', error);
      throw error;
    }
  },
};